import { authFetch, apiUrl } from "../utils/api";

export const conversationApi = {
  list(options) {
    return authFetch(apiUrl("/api/conversations"), options);
  },

  get(conversationId, options) {
    return authFetch(
      apiUrl(`/api/chat/conversations/${encodeURIComponent(conversationId)}`),
      options,
    );
  },

  create({ title = "New Chat" } = {}) {
    return authFetch(apiUrl("/api/conversations"), {
      method: "POST",
      body: JSON.stringify({ title }),
    });
  },

  saveMessage(conversationId, message) {
    return authFetch(apiUrl("/api/messages"), {
      method: "POST",
      body: JSON.stringify({
        conversationId,
        role: message.role,
        content: message.content,
        contentBlocks: message.contentBlocks || null,
        provider: message.provider,
        model: message.model,
        latency: message.latency,
        timestamp: message.timestamp,
      }),
    });
  },
};

export function sanitizeConversationMessages(messages = []) {
  return messages.map((message) => ({
    ...message,
    cost: typeof message.cost === "string" ? 0 : message.cost || 0,
  }));
}

export default conversationApi;
